import PropTypes from 'prop-types';
import CharacterCounter from 'apps/interactions/components/character-counter';
import { useRef } from 'react';
import { RichTextEditor, stripHtml } from '@evertrue/sdk';
import { useInteractionFormContext } from 'apps/interactions/form/context/interaction-form-context';
import { INTERACTION_CHARACTER_LIMIT } from 'apps/proposals/utils';

const TextField = ({
  id,
  onChange,
  onBlur,
  name,
  value = '',
  type = 'standard',
  required = false,
  field,
  meta,
  helpers,
}) => {
  const { interactionStandardFieldsConfig, interactionDescriptionRichTextEditor } = useInteractionFormContext();
  const joditRef = useRef(null);

  const isStandardInteraction = type === 'standard';
  const maxLength = isStandardInteraction
    ? interactionStandardFieldsConfig?.text?.max_length
    : interactionStandardFieldsConfig?.dxo_text?.max_length;
  const defaultMaxLength = isStandardInteraction
    ? INTERACTION_CHARACTER_LIMIT?.TEXT
    : INTERACTION_CHARACTER_LIMIT?.DXO_TEXT;

  return (
    <>
      {interactionDescriptionRichTextEditor && isStandardInteraction ? (
        <div className="rte-container">
          {/* NOTE: the RichTextEditor does NOT handle onChange and onBlur in ways that a typical input would
          Most inputs take in an event object with a target property that contains the name and value.
          The RichTextEditor takes in a value and onChange function that returns the new value.
          This is why we are using the helpers.setValue and onBlur functions directly instead of passing them through.
           */}
          <RichTextEditor
            id={id}
            name={name}
            autofocus={false}
            ref={joditRef}
            value={value || ''}
            additionalConfig={{ placeholder: 'Add details...' }}
            onChange={(newValue) => {
              // If the newValue is null, undefined, or an empty rich text, set it to an empty string
              if (newValue === null || newValue === undefined || stripHtml(newValue).length === 0) {
                newValue = '';
              }
              helpers.setValue(newValue);
            }}
            onBlur={(newValue) => {
              onBlur({ target: { name, value: newValue } });
            }}
          />
        </div>
      ) : (
        <textarea
          id={id}
          name="text"
          value={value}
          placeholder="Add details..."
          onChange={onChange}
          onBlur={onBlur}
          style={{ height: '184px ' }} // adding this to match style of Legacy Interaction Form
          // maxLength={maxLength} this seems like the easiest and best way to handle max length validation but :shrug:
        />
      )}
      {maxLength < defaultMaxLength && (
        <CharacterCounter
          count={
            interactionDescriptionRichTextEditor && isStandardInteraction
              ? stripHtml(value).replace(/\n/g, '').length
              : value.replace(/\n/g, '').length
          }
          limit={maxLength}
        />
      )}
    </>
  );
};

TextField.propTypes = {
  id: PropTypes.string,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  name: PropTypes.string,
  value: PropTypes.string,
  type: PropTypes.oneOf(['standard', 'dxo']),
  required: PropTypes.bool,
  field: PropTypes.shape({
    name: PropTypes.string,
    onBlur: PropTypes.func,
    onChange: PropTypes.func,
    value: PropTypes.any,
    checked: PropTypes.bool,
    multiple: PropTypes.bool,
  }),
  meta: PropTypes.shape({
    error: PropTypes.string,
    initialError: PropTypes.string,
    initialTouched: PropTypes.bool,
    initialValue: PropTypes.any,
    touched: PropTypes.bool,
    value: PropTypes.any,
  }),
  helpers: PropTypes.shape({
    setValue: PropTypes.func,
    setTouched: PropTypes.func,
    setError: PropTypes.func,
  }),
};
export default TextField;
